import { render, staticRenderFns, recyclableRender, components } from "./wallet.vue?vue&type=template&id=44c5d18e&scoped=true&"
var renderjs
import script from "./wallet.vue?vue&type=script&lang=js&"
export * from "./wallet.vue?vue&type=script&lang=js&"
import style0 from "./wallet.vue?vue&type=style&index=0&id=44c5d18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c5d18e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/wallet/wallet.vue"
export default component.exports